import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'setupSubInfo'
})
export class SetupSubInfoPipe implements PipeTransform {
  private getHours(dateObj: any, lang: any) {
    if (dateObj.getUTCHours() > 0) {
      return dateObj.getUTCHours() + (lang == "el" ? "ω" : "h") + " ";
    } else {
      return "";
    }
  }
  private getMinutes(dateObj: any, lang: any) {
    return dateObj.getUTCMinutes() + (lang == "el" ? "λ" : "m");
  }
  transform(details: any, ...args: any[]): unknown {
    let subInfo = "";
    if (details && details.genres && details.genres.length) {
      subInfo += details.genres.join(",");
    }

    if (details && details.year) {
      subInfo += (subInfo ? " ‧ " : " ") + details.year;
    }

    if (details?.media?.duration) {
      let dateObj = new Date(details?.media?.duration * 1000);
      subInfo += (subInfo ? " ‧ " : " ") + this.getHours(dateObj, args[0]) + this.getMinutes(dateObj, args[0]);
    }

    if (details && details?.rating >= 0 && details?.rating < 5) {
      subInfo += (subInfo ? " ‧ " : " ") + '<img class="parental-icon" src = "assets/images/parentalRatings/' + details.rating + '.png" />';
    }


    if (details && details.customParameters && details.customParameters.award) {
      subInfo += (subInfo ? " ‧ " : " ") + "<i class='asset-award-details fa fa-medal'></i> <span class='clr-theme'>" + JSON.parse(details.customParameters.award)[args[0]] + "</span>";
    }

    return subInfo;
  }
}